<app-segment-header title="applicant-tracker.jobInformation" />
<form #form="ngForm" autocomplete="off">
    <ng-container *ngIf="readyToRender">
        <div class="app-grid centered">
            <app-location-type-select
                [jobPosting]="jobPosting"
                [locationTypes]="jobPosting.allLocationTypes"
                class="columns-4 small-columns-12"
            ></app-location-type-select>
            <ui-info
                class="columns-1 justify-start"
                text="{{ 'forms.applicant-tracker.tooltipLocationType' | translate }}"
            ></ui-info>
        </div>

        <div class="app-grid">
            <app-address-search
                [jobPosting]="jobPosting"
                class="d-inline-block columns-4 small-columns-12"
            ></app-address-search>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'forms.applicant-tracker.unitSuite' | translate }}</mat-label>

                <input
                    type="text"
                    matInput
                    #addressLine2="ngModel"
                    name="addressLine2"
                    [(ngModel)]="jobPosting.addressLine2"
                    placeholder="{{ 'forms.applicant-tracker.unitSuitePlaceholder' | translate }}"
                />
                <mat-error *ngIf="addressLine2.invalid">{{ addressLine2?.errors | formErrors }}</mat-error>
            </mat-form-field>

            <br />

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'forms.applicant-tracker.city' | translate }}</mat-label>

                <input
                    type="text"
                    matInput
                    required
                    #city="ngModel"
                    name="city"
                    [(ngModel)]="jobPosting.city"
                    placeholder="{{ 'forms.applicant-tracker.cityPlaceholder' | translate }}"
                />
                <mat-error *ngIf="city.invalid">{{ city?.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'forms.applicant-tracker.provinceState' | translate }}</mat-label>

                <input
                    type="text"
                    matInput
                    required
                    #region="ngModel"
                    name="region"
                    [(ngModel)]="jobPosting.region"
                    placeholder="{{ 'forms.applicant-tracker.provincePlaceholder' | translate }}"
                />
                <mat-error *ngIf="region.invalid">{{ region?.errors | formErrors }}</mat-error>
            </mat-form-field>

            <br />

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'forms.applicant-tracker.postalZipCode' | translate }}</mat-label>

                <input
                    type="text"
                    matInput
                    #postalCode="ngModel"
                    name="postalCode"
                    [(ngModel)]="jobPosting.postalCode"
                    placeholder="{{ 'forms.applicant-tracker.postalZipCodePlaceholder' | translate }}"
                />
                <mat-error *ngIf="postalCode.invalid">{{ postalCode?.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'forms.applicant-tracker.country' | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    required
                    #country="ngModel"
                    name="country"
                    [(ngModel)]="jobPosting.country"
                    placeholder="{{ 'forms.applicant-tracker.countryPlaceholder' | translate }}"
                />
                <mat-error *ngIf="country.invalid">{{ country.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <app-compensation-type-select
                [jobPosting]="jobPosting"
                class="d-inline-block columns-4 small-columns-6"
            ></app-compensation-type-select>

            <mat-form-field class="columns-2 small-columns-3" *ngIf="jobPosting.compensationType != null">
                <mat-label
                    >{{ 'forms.applicant-tracker.compensationRange' | translate }}
                    <div class="sr-only">{{ 'forms.fields.minimumValue' | translate }}</div></mat-label
                >
                <input
                    type="number"
                    matInput
                    min="0"
                    #payLow="ngModel"
                    name="payLow"
                    [(ngModel)]="jobPosting.payLow"
                    [placeholder]="jobPosting.payLowPlaceholder | appTranslate"
                />
                <mat-error *ngIf="payLow.invalid">{{ payLow.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field
                class="columns-2 small-columns-3 compensationPayHighV2"
                *ngIf="jobPosting.compensationType != null"
            >
                <mat-label class="sr-only"
                    >{{ 'forms.applicant-tracker.compensationRange' | translate }}
                    {{ 'forms.fields.maximumValue' | translate }}</mat-label
                >
                <input
                    type="number"
                    matInput
                    #payHigh="ngModel"
                    min="0"
                    name="payHigh"
                    [(ngModel)]="jobPosting.payHigh"
                    [placeholder]="jobPosting.payHighPlaceholder | appTranslate"
                />
                <mat-error *ngIf="payHigh.invalid">{{ payHigh.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-8 small-columns-12">
                <mat-label>{{ 'forms.applicant-tracker.descriptionWithMsg' | translate }}</mat-label>
                <!-- There is an offset of 11 for minLength. There is an issue with ui rich text-->
                <ui-rich-text
                    [(ngModel)]="jobPosting.description"
                    name="description"
                    required
                    height="auto"
                    #description="ngModel"
                    [stripNewlines]="true"
                    [displayColorOptions]="true"
                    [minlength]="41"
                ></ui-rich-text>
                <mat-error *ngIf="description.invalid">{{
                    'forms.applicant-tracker.descriptionLengthError' | translate
                }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
